import { takeLatest, takeEvery, put, call } from 'redux-saga/effects';
import { Map } from 'immutable';

import * as deviceGroupsApi from 'src/service/api/deviceGroups';
import * as navigationActions from 'src/module/navigation/action';
import * as recipeActions from 'src/module/recipe/action';

import * as filterActions from 'src/module/filter/action';
import * as deviceGroupsActions from './action';

import toast from 'src/utils/toast';
import { createUserFriendlyErrorMessage } from 'src/utils/utils';

export function * groupDevicesRoot () {
  yield takeLatest(deviceGroupsActions.FETCH_DEVICE_GROUPS, fetchDeviceGroups);
  yield takeLatest(deviceGroupsActions.DELETE_DEVICE_GROUP, deleteDeviceGroup);
  yield takeLatest(deviceGroupsActions.CREATE_DEVICE_GROUP, createDeviceGroup);
  yield takeLatest(deviceGroupsActions.UPDATE_DEVICE_GROUP, updateDeviceGroup);
  yield takeLatest(deviceGroupsActions.FETCH_DEVICE_GROUP_FOR_EDIT, fetchDeviceGroupForEdit);
  yield takeLatest(deviceGroupsActions.FETCH_DEVICE_GROUPS_LABELS, fetchDeviceGroupsLabels);
  // takeEvery, not takeLatest: expanding a second row must not cancel the first row's load
  yield takeEvery(deviceGroupsActions.EXPAND_DEVICE_GROUP_DEVICES, expandDeviceGroupDevices);
}

function * fetchDeviceGroups (action) {
  try {
    const deviceGroups = yield call(deviceGroupsApi.getDeviceGroups, action);
    yield put(deviceGroupsActions.fetchDeviceGroupsSuccess(deviceGroups.get('data'), deviceGroups.get('total'), deviceGroups.get('totalPages')));
  } catch (err: any) {
    toast.error(createUserFriendlyErrorMessage(err, 'Error fetching device groups!'), err);
    yield put(deviceGroupsActions.fetchDeviceGroupsFailed(Map(err)));
  }
}
function * fetchDeviceGroupsLabels (action) {
  try {
    const deviceGroups = yield call(deviceGroupsApi.getDeviceGroupsLabels, action);
    yield put(deviceGroupsActions.fetchDeviceGroupsLabelsSuccess(deviceGroups));
    yield put(filterActions.fetchDeviceGroupsOptionsSuccess(deviceGroups.map(x => {return Map({ device_group: x.get('group_name'), id: x.get('id') });})));

  } catch (err: any) {
    yield put(deviceGroupsActions.fetchDeviceGroupsLabelsFailed(Map(err)));
  }
}
function * deleteDeviceGroup (action) {
  try {
    yield call(deviceGroupsApi.deleteDeviceGroupById, action);
    yield put(deviceGroupsActions.deleteDeviceGroupSuccess(action.groupId));
  } catch (err: any) {
    toast.error(createUserFriendlyErrorMessage(err, 'Error deleting device group'), err.response);
    yield put(deviceGroupsActions.deleteDeviceGroupFailed(Map(err)));
  }
}
function * createDeviceGroup (action) {
  try {
    const rec = yield call(deviceGroupsApi.createDeviceGroup, action);
    if (action.redirectOnSuccess) {
      yield put(navigationActions.pushHistory("/devices/groups"));
    } else {
      // set a store value to close the modal
      yield put(recipeActions.closeAddGroupModal());
    }
    // add to store
    yield put(deviceGroupsActions.createDeviceGroupSuccess(action.groupName, rec.get('devices'), rec.get('id'), rec.get('count')));

  } catch (err: any) {
    toast.error(createUserFriendlyErrorMessage(err, 'Error creating device group'), err.response);
    yield put(deviceGroupsActions.createDeviceGroupFailed(Map(err)));
  }
}

function * updateDeviceGroup (action) {
  try {
    const rec = yield call(deviceGroupsApi.updateDeviceGroup, action);
    yield put(deviceGroupsActions.updateDeviceGroupSuccess(action.groupId, action.groupName, rec.get('devices'), rec.get('count')));
    toast.success('Device group updated');
    if (action.redirectOnSuccess) {
      yield put(navigationActions.pushHistory("/devices/groups"));
    } else {
      yield put(recipeActions.closeAddGroupModal());
    }
  } catch (err: any) {
    toast.error(createUserFriendlyErrorMessage(err, 'Error updating device group'), err.response);
    yield put(deviceGroupsActions.updateDeviceGroupFailed(Map(err)));
  }
}

// getDeviceGroup is uncapped, so this returns the group's whole membership — which is what the
// edit screen needs to pre-check the right boxes.
function * fetchDeviceGroupForEdit (action) {
  try {
    const group = yield call(deviceGroupsApi.getDeviceGroup, action);
    yield put(deviceGroupsActions.fetchDeviceGroupForEditSuccess(group));
  } catch (err: any) {
    toast.error(createUserFriendlyErrorMessage(err, 'Error fetching device group'), err.response);
    yield put(deviceGroupsActions.fetchDeviceGroupForEditFailed(Map(err)));
  }
}

// getDeviceGroup is deliberately uncapped, so this returns the group's whole membership.
function * expandDeviceGroupDevices (action) {
  try {
    const group = yield call(deviceGroupsApi.getDeviceGroup, action);
    yield put(deviceGroupsActions.expandDeviceGroupDevicesSuccess(action.groupId, group.get('devices')));
  } catch (err: any) {
    toast.error(createUserFriendlyErrorMessage(err, 'Error fetching device group devices'), err.response);
    yield put(deviceGroupsActions.expandDeviceGroupDevicesFailed(action.groupId, Map(err)));
  }
}

export default fetchDeviceGroups;
